module.exports = __webpack_public_path__ + "img/bg_1@2x.e6c4d4d6.png";